import {Button, Center, FileInput, Image, Modal, Stack, TextInput} from "@mantine/core";
import React, {useEffect, useState} from "react";
import {notifications, showNotification} from "@mantine/notifications";
import {IconCheck} from "@tabler/icons-react";
import {Company, CompanyAPI} from "../../api/company/CompanyAPI";

export type UpdateCompanyProps = {
  justClose: () => void;
  closeAndUpdate: () => void;
  company: Company | null | undefined;
}

export function UpdateCompanyModal(attrs: UpdateCompanyProps) {
  const isOpen = attrs.company !== null && attrs.company !== undefined;
  const [title, setTitle] = useState<string>("");
  const [isLoading, setLoading] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [imageHash, setImageHash] = useState<number>();

  const onSubmit = () => {
    if (!attrs.company) {
      notifications.show({
        title: "Nie udało się zaktualizować firmy",
        message: "Nie udało się zaktualizować firmy. Brak firmy do aktualizacji.",
        color: "red",
        icon: <IconCheck/>
      });

      return;
    }

    CompanyAPI.updateAsync(attrs.company.id, {title, file})
      .then(() => {
        showNotification({
          title: "Zaktualizowano firmę!",
          message: "Firma została utworzona.",
          color: "green",
          icon: <IconCheck/>
        })
      })
      .then(attrs.closeAndUpdate)
      .finally(() => {
        setLoading(false);
        setImageHash(Date.now());
      });
  }

  const reload = () => {
    if (attrs.company) {
      setTitle(attrs.company.title);
      setFile(null);
    }
  }

  useEffect(reload, [isOpen, attrs.company]);

  return (
    <Modal opened={isOpen} onClose={attrs.justClose} title="Edycja firmy">
      <Stack>
        <TextInput
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Nazwa firmy"
          description="Nazwa firmy"
        />

        <FileInput
          clearable
          accept=".jpeg"
          placeholder="Wybierz plik"
          value={file}
          onChange={setFile}
        />

        { attrs.company && (
          <Center>
            <Image
              key={CompanyAPI.getFileUrl(attrs.company.id) + `?v=${imageHash}`}
              w="10vw"
              h={'10vh'}
              src={CompanyAPI.getFileUrl(attrs.company.id) + `?v=${imageHash}`}
            />
          </Center>
        )}

        <Button
          onClick={onSubmit}
          loading={isLoading}
        >
          Zapisz
        </Button>
    </Stack>
</Modal>
)
}